import axios from "axios";
import i18n from "../i18n/i18n";
const currentLanguage = i18n.language;
console.log(currentLanguage, "currentLanguage");
// Adding website URL
// TODO: Please Change live URL while moving to live
export const WEBSITE_BASE_URL = "https://greenman.energy"; //As of now using stagging url
export const buildWebsiteUrl = (path) =>
  currentLanguage == "en"
    ? `${WEBSITE_BASE_URL}/en${path}`
    : `${WEBSITE_BASE_URL}${path}`;

const apiKit = axios.create({
  // baseURL: "https://cotyledonal-undestructibly-jacques.ngrok-free.dev/api/",
  // baseURL: "https://leading-welcome-akita.ngrok-free.app/api/",
  baseURL: "https://stromrechner.greenman.energy/api/",
});

apiKit.interceptors.request.use(
  async (config) => {
    // const token = await SecureStore.getItemAsync("token");
    config.headers["ngrok-skip-browser-warning"] = "12321";
    // if (token) {
    //   config.headers["Authorization"] = token;
    // }
    return config;
  },
  (error) => {
    Promise.reject(error);
    console.log(error);
  },
);

export default apiKit;
